import { c as _c } from "react/compiler-runtime";
import { SystemStyleObject, Text } from "@chakra-ui/react";
import ResponsiveTextWithHighlight from "./responsive-text-with-highlight";
export interface HeadingProps {
  text: string;
  highlight: string;
  style?: SystemStyleObject;
  highlightStyle?: SystemStyleObject;
  maxWidth?: {
    [key: string]: string;
  };
  themeTextStyle: SystemStyleObject["textStyle"];
}
const Heading: React.FC<{
  headingData: HeadingProps;
}> = t0 => {
  const $ = _c(9);
  const {
    headingData
  } = t0;
  const {
    text,
    highlight,
    style,
    highlightStyle,
    maxWidth,
    themeTextStyle
  } = headingData;
  let t1;
  if ($[0] !== highlight || $[1] !== highlightStyle || $[2] !== text) {
    t1 = <ResponsiveTextWithHighlight text={text} highlight={highlight} highlightStyle={highlightStyle} />;
    $[0] = highlight;
    $[1] = highlightStyle;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== maxWidth || $[5] !== style || $[6] !== t1 || $[7] !== themeTextStyle) {
    t2 = <Text textStyle={themeTextStyle} maxW={maxWidth} css={style}>{t1}</Text>;
    $[4] = maxWidth;
    $[5] = style;
    $[6] = t1;
    $[7] = themeTextStyle;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default Heading;